const state = {
    flashmessage: {
        message: '',
        type: 'success',
        autohide: true
    }
}

const getters = {
    flashmessage: state => state.flashmessage
}

const actions = {
    addFlashMessage ({ state, commit }, message) {
        if (!message.autohide) {
            message.autohide = true
        }
        commit('addFlashMessage', message)
    },

    removeFlashMessage ({ state, commit }) {
        commit('removeFlashMessage')
    }
}

const mutations = {
    addFlashMessage (state, message) {
        state.flashmessage = message
    },

    removeFlashMessage (state) {
        state.flashmessage = {
            message: '',
            type: 'success'
        }
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
